export default "__VITE_ASSET__BLTpVGNU__"